import { gql } from '@apollo/client';
import client from '../../../../core/services/graphql';

export const deleteAttachment = async (id) => {
  const query = gql`
    mutation deleteAttachment($attachmentId: ID!) {
      deleteAttachment(attachmentId: $attachmentId) {
        void
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation: query,
    variables: { attachmentId: id },
  });

  return data;
};
